import clsx from 'clsx'

import { type SingleSelectedValueFilter } from 'components/brokers/types'
import { Switch } from 'components/ui/switch'

const HsaEligibleFilter = ({
  selectValue,
  selectedValue,
}: SingleSelectedValueFilter) => {
  const handleSelect = (isSelected: boolean) => {
    selectValue(isSelected ? 'true' : 'false')
  }

  return (
    <div
      style={{ width: '300px' }}
      className={clsx({
        'rounded-md bg-slate-50 flex items-center justify-between px-2 py-1 text-sm':
          true,
        'text-thatch-purple': selectedValue,
        'text-ds-text-secondary': !selectedValue,
      })}
    >
      <div>HSA Eligible?</div>
      <div className='ml-auto flex items-center justify-between space-x-2 shrink-0 h-2'>
        <Switch checked={selectedValue === 'true'} onCheckedChange={handleSelect} />
      </div>
    </div>
  )
}

export default HsaEligibleFilter
